import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'

export const INITIAL_STATE = Immutable({
  loading: false,
  data: {},
})

const { Types, Creators } = createActions({
  getDelivereeReport: ['startAt', 'endAt'],
  setDelivereeReport: ['data'],
  setDelivereeReportLoading: ['val']
})

export const getDelivereeReportReducer = state => state.set('loading', true)

export const setDelivereeReportReducer = (state, { data }) =>
  state.set('loading', false).set('data', data)

export const setDelivereeReportLoadingReducer = (state, { val }) => state.set('loading', val)

export const delivereeReportReducer = createReducer(INITIAL_STATE, {
  [Types.GET_DELIVEREE_REPORT]: getDelivereeReportReducer,
  [Types.SET_DELIVEREE_REPORT]: setDelivereeReportReducer,
  [Types.SET_DELIVEREE_REPORT_LOADING]: setDelivereeReportLoadingReducer,
})

export const DelivereeReportTypes = Types
export default Creators



// WEBPACK FOOTER //
// ./src/reducers/delivereeReportReducer.js